import React, { useEffect, useState } from 'react'
import axiosClient from '../../../axios/axiosClient';
// import './search.css'

function SearchBeneficiary() {

    const [loading, setLoading] = useState([]);
    const [search, setSearch] = useState([]);
    const [searchResult, setSearchResult] = useState([]);

    const searchBeneficiary = () =>{
        setLoading(true);
        axiosClient
        .get(`/beneficiaries/search?search=${search}`)
        .then((response) => {
          setSearchResult(response.data.data)
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
      }
      const handleKeyDown = (e) => {
        if (e.key === "Enter") {
          e.preventDefault();  
          searchBeneficiary()
        }
      };
  

      useEffect(()=>{
        searchBeneficiary()
      },[search])
    return (

        <li>
                <form className="form-inline search-form" action="index.html#" method="get">
                  <div className="form-group me-0">
                    <div className="Typeahead Typeahead--twitterUsers">
                      <div className="u-posRelative">
                        <input className="Typeahead-input form-control-plaintext" id="demo-input" type="text" name="q" placeholder="Search beneficiary..."  onChange={(e) => setSearch(e.target.value)} onKeyDown={handleKeyDown} />
                        <div className="spinner-border Typeahead-spinner" role="status">
                          {loading && <span className="sr-only">Loading...</span>}
                        </div>
                        <span className="d-sm-none mobile-search"><i data-feather="search"></i></span>
                      </div>
                      <div className="Typeahead-menu">
                        {searchResult.length > 0 && searchResult.map((result, index) => (
                          <a href={`/view-beneficiary/${result.id}`} style={{textDecoration:"none", color:"inherit"}}>
                              <div class="ProfileCard u-cf Typeahead-suggestion Typeahead-selectable" key={index} >
                                <div class="ProfileCard-avatar">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-airplay m-0">
                                  <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                                  <polygon points="12 15 17 21 7 21 12 15"></polygon>
                                  </svg>
                                  </div><div class="ProfileCard-details">
                                    <div class="ProfileCard-realName">{result.first_name} {result.last_name}</div>
                                </div>
                              </div>
                          </a>
                              //  <div key={index} className="ProfileCard-realName">{result.first_name} {result.last_name}</div>
                            ))}

                      </div>
                    </div>
                  </div>
                </form>
        </li>

    )
}

export default SearchBeneficiary
